import { render, staticRenderFns } from "./robotMessage.vue?vue&type=template&id=8e2020fc"
import script from "./robotMessage.vue?vue&type=script&lang=js"
export * from "./robotMessage.vue?vue&type=script&lang=js"
import style0 from "./robotMessage.vue?vue&type=style&index=0&id=8e2020fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports